<template>
  <div>
    <type-period v-model="years"
                 :disabled="disabled"
                 :hints="'请选择年限'"
                 :multiple="true" />
    <type-age v-model="ages"
              :disabled="disabled"
              :hints="'请选择年龄'"
              :multiple="true" />
  </div>

</template>
<script>
import LibProductItem from '../../../minxin/ProductItem';
import TypeAge from './TypeAge';
import TypePeriod from './TypePeriod';

export default {
  name: "ProductItemTypePeriodsAndAges",
  mixins: [LibProductItem],
  components: {
    TypeAge,
    TypePeriod
  },
  props: {
    value: [Object],
  },
  data() {
    return {
    }
  },
  computed: {
    years: {
      get: function () { return this.currentValue.years || [] },
      set: function (n) {
        let v = this.currentValue;
        v.years = n;
        this.$emit('input', v)
      }
    },
    ages: {
      get: function () { return this.currentValue.ages || [] },
      set: function (n) {
        let v = this.currentValue;
        v.ages = n;
        this.$emit('input', v)
      }
    },
    currentValue() {
      return JSON.parse(JSON.stringify(this.value || {})) || {}
    }
  },
}
</script>
